import React, { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps extends PropsWithChildren {
  root: 'footer' | 'tester';
}

const Portal: React.FC<PortalProps> = ({ children, root }) => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalRoot(document.getElementById(root));
  }, [root]);

  if (!portalRoot) return null;

  return createPortal(children, portalRoot);
};

export default Portal;
